import $ from 'jquery';
import ko from 'knockout';

/**
 * Binding to make an element act as a drop zone for file uploads. Child elements within the element will
 * trigger the "dragleave" so a counter is used to determine when enter and leave events occurs just on
 * the element and not child elements.
 */
ko.bindingHandlers.fileDropZone = {
  init: function (element, valueAccessor) {

    var dropZoneElement = $(element);
    var addFileUploadsCallback = valueAccessor();
    var counter = 0;

    dropZoneElement.on('dragover', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    dropZoneElement.on('dragenter', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter++;

      dropZoneElement.css('background-color', '#FDFFB7');
    });

    dropZoneElement.on('dragleave', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter--;

      if (counter === 0) {
        dropZoneElement.css('background-color', '');
      }
    });

    dropZoneElement.on('drop', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter = 0;
      dropZoneElement.css('background-color', '');

      var fileList = e.originalEvent.dataTransfer.files;
      addFileUploadsCallback(fileList);
    });
  }
};

